module.exports = __webpack_public_path__ + "img/number2.c15d406c.svg";